import React from "react"

export const SibilusCheckbox = ({checked, onChange, id, children, className=null, name=null}) => {
	return (
		<div className={`sibilus_checkbox d-flex${className ? " " + className : ""}`} onChange={onChange}>
			<input
				id={id}
				type="checkbox"
				checked={checked}
				onChange={onChange}
				name={name}
			/>
			<label htmlFor={id}></label>
			<label className="checkbox_text ps-2" htmlFor={id}>
				{children}
			</label>
		</div>
	)
}
